import { meetingBodyLink } from './links.js';
import { campaignJoinDimensions, campaignJoinTimeDimensions } from './shared-dimensions.js';
import { seatTermApplicationStatusValueLabels, seatTermStatusValueLabels, seatTypeValueLabels, } from './value-labels.js';
/**
 * Combination data source: Applications x Campaigns x Seats.
 * Row-level detail of every application submitted through a campaign, linking applicants to the
 * specific seats and terms they applied for.
 */
export const campaignApplicationsCube = {
    category: 'Applications',
    description: 'Every application submitted through a campaign, linked to the specific seats and terms applied for.',
    label: 'Applications by Campaign',
    requiredModule: 'hasTenure',
    measures: {
        'campaign_applications.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        // Application
        'campaign_applications.status': {
            label: 'Application Status',
            type: 'string',
            valueLabels: seatTermApplicationStatusValueLabels,
        },
        // Applicant
        'seat_applications.first_name': { label: 'Applicant First Name', type: 'string' },
        'seat_applications.last_name': { label: 'Applicant Last Name', type: 'string' },
        ...campaignJoinDimensions,
        // Meeting Body
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
        // Seat
        'meeting_body_seats.number': { label: 'Seat Number', type: 'number' },
        'meeting_body_seats.title': { label: 'Seat Title', type: 'string' },
        'meeting_body_seats.type': {
            label: 'Seat Type',
            type: 'string',
            valueLabels: seatTypeValueLabels,
        },
        // Term
        'meeting_body_seat_terms.number': { label: 'Term Number', type: 'number' },
        'meeting_body_seat_terms.is_current': { label: 'Term Is Current', type: 'boolean' },
        'meeting_body_seat_terms.status': {
            label: 'Term Status',
            type: 'string',
            valueLabels: seatTermStatusValueLabels,
        },
    },
    timeDimensions: {
        'campaign_applications.created_at': { label: 'Application Created At', type: 'date' },
        'meeting_body_seat_terms.start_date': { label: 'Term Start Date', type: 'date' },
        'meeting_body_seat_terms.end_date': { label: 'Term End Date', type: 'date' },
        ...campaignJoinTimeDimensions,
    },
};
